// ToggleSwitch.js
// iOS-style toggle switch component for use throughout the application

import React from "react";
import styles from "./ToggleSwitch.module.css";

/**
 * iOS-style toggle switch component
 * @param {boolean} checked - Whether the toggle is on
 * @param {function} onChange - Callback when toggle is clicked, receives new checked state
 * @param {boolean} disabled - Whether the toggle is disabled
 * @param {string} label - Optional label text to display next to toggle
 * @param {string} id - Optional id for the input element
 */
export const ToggleSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  label = "",
  id = "",
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  const handleKeyDown = (e) => {
    if ((e.key === "Enter" || e.key === " ") && !disabled) {
      e.preventDefault();
      onChange(!checked);
    }
  };

  return (
    <div className={styles.toggleContainer}>
      {label && (
        <label
          className={`${styles.toggleLabel} ${disabled ? styles.disabled : ""}`}
          htmlFor={id}
        >
          {label}
        </label>
      )}
      <div
        id={id}
        role="switch"
        aria-checked={checked}
        aria-disabled={disabled}
        tabIndex={disabled ? -1 : 0}
        className={`${styles.toggleTrack} ${checked ? styles.checked : ""} ${
          disabled ? styles.disabled : ""
        }`}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        <div className={styles.toggleKnob} />
      </div>
    </div>
  );
};

export default ToggleSwitch;